import { motion } from "framer-motion";
import Video from "../components/Video";
import { LineReveal } from "../components/Reveal";
import SectionLabel from "../components/SectionLabel";
import { V } from "../data/site";

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden px-6 md:px-12 lg:px-16 py-32 md:py-52" data-testid="about">
      {/* subtle moving video background */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.14]">
        <Video src={V.motion1} priority className="h-full w-full" />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10">
        <SectionLabel index="10">ABOUT</SectionLabel>
        <LineReveal
          className="mt-10"
          lineClass="text-huge uppercase"
          lines={[
            "WE BUILD THE SYSTEM",
            <span key="l2">
              BEHIND THE <span className="text-lav-400">CONTENT.</span>
            </span>,
          ]}
        />
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="mt-12 max-w-2xl text-base md:text-xl font-light leading-relaxed text-white/60"
        >
          twentyone studios is a content studio for founders and brands who
          treat attention as an asset. We engineer short-form, personal brand
          systems and conversion content — then wire it directly to revenue.
          Fewer, sharper pieces. Built to move.
        </motion.p>
      </div>
    </section>
  );
}
